// src/components/CollectorProfileCard.jsx
// Affiche sur le tableau de bord l'archétype de collectionneur issu du quiz
// (profiles.archetype / quiz_affinity / transmission_index), avec un accès pour
// refaire le test. Sans résultat enregistré : invitation à passer le test.
import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { VISION_URL } from "../config/domains";

const ARCHETYPE_UI = {
  batisseur: { emoji: "📈", color: "#2563eb" },
  passionne: { emoji: "❤️", color: "#dc2626" },
  connecteur: { emoji: "🤝", color: "#7c3aed" },
  gardien: { emoji: "🏛️", color: "#0f766e" },
  mecene: { emoji: "✨", color: "#c9a961" },
};

const QUIZ_URL = `${VISION_URL}/quiz-collectionneur`;

export default function CollectorProfileCard() {
  const { t } = useTranslation();
  const { profile } = useAuth();

  const key = profile?.archetype;
  const ui = key ? ARCHETYPE_UI[key] : null;
  const affinity = profile?.quiz_affinity;
  const tIndex = profile?.transmission_index;

  if (!ui) {
    return (
      <div className="bg-white rounded-lg shadow p-5 mb-6 border border-gray-100">
        <p className="text-xs uppercase tracking-widest text-gray-500 mb-1">
          {t("collectorProfile.eyebrow")}
        </p>
        <h3 className="text-lg font-semibold text-gray-900 mb-1">
          {t("collectorProfile.empty.title")}
        </h3>
        <p className="text-sm text-gray-600 mb-4">{t("collectorProfile.empty.body")}</p>
        <a
          href={QUIZ_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-gray-900 text-white text-sm px-4 py-2 rounded-lg hover:bg-gray-700"
        >
          {t("collectorProfile.empty.cta")}
        </a>
        <p className="text-xs text-gray-500 mt-3">{t("collectorProfile.retakeHint")}</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-5 mb-6 border border-gray-100">
      <p className="text-xs uppercase tracking-widest text-gray-500 mb-3">
        {t("collectorProfile.eyebrow")}
      </p>
      <div className="flex items-center gap-4">
        <span
          className="flex items-center justify-center rounded-full text-2xl shrink-0"
          style={{ width: 52, height: 52, background: `${ui.color}1a` }}
        >
          {ui.emoji}
        </span>
        <div className="min-w-0">
          <div className="text-lg font-bold" style={{ color: ui.color }}>
            {t(`bienvenue.archetype.${key}`)}
            {affinity != null && (
              <span className="ml-2 text-sm font-medium text-gray-500">
                {t("collectorProfile.affinity", { pct: affinity })}
              </span>
            )}
          </div>
          <p className="text-sm text-gray-600 italic">{t(`collectorProfile.tagline.${key}`)}</p>
        </div>
      </div>
      {tIndex != null && (
        <p className="text-sm text-gray-700 mt-3">
          {t("collectorProfile.transmission", { pct: tIndex })}
        </p>
      )}
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <a
          href={QUIZ_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block border border-gray-300 text-sm px-4 py-2 rounded-lg hover:bg-gray-50"
        >
          {t("collectorProfile.retake")}
        </a>
        <span className="text-xs text-gray-500">{t("collectorProfile.retakeHint")}</span>
      </div>
    </div>
  );
}
